import {
  productsEndpoint,
  accountsEndpoint,
} from "../../config/ecomConfig"

export const getLocation = async () => {
  try {
    const response = await fetch(
      `https://pro.ip-api.com/json/?key=${process.env.GATSBY_IP_API_KEY}&fields=status,currency,country,countryCode`
    )
    if (response.ok) {
      return await response.json()
    }
    throw new Error(response.statusText)
  } catch (error) {
    console.log("Error", error)
  }
  return null
}

export const getAccounts = async (userKey, onError = () => {}) => {
  try {
    let refreshedKey
    if (userKey !== JSON?.parse(localStorage.getItem("user-trial-data"))?.id) {
      refreshedKey = JSON?.parse(localStorage.getItem("user-trial-data"))?.id
    }
    let requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${refreshedKey ? refreshedKey : userKey}`,
        "Content-Type": "application/json",
      },
    }
    const response = await fetch(`${accountsEndpoint}/accounts`, requestOptions)
    const data = await response.json()
    if (response.ok) {
      return data
    }
    throw new Error()
  } catch (error) {
    console.log("Error", error)
    onError()
  }
  return null
}

export const createAccount = async userKey => {
  let data = null
  const userInfo = localStorage.getItem("user_info")

  try {
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${userKey}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user: { phoneNumber: "string" },
        accountType: "Organization",
        businessInfo: {
          companyName: userInfo?.email || "string",
          companySize: "0",
          country: "",
          taxExemptionType: "NO_EXEMPTION",
        },
        address: {
          country: "",
          streetAddress: "",
          city: "",
          state: "",
          postalCode: "",
        },
        marketingConsent: false,
      }),
      redirect: "follow",
    }

    const response = await fetch(`${accountsEndpoint}/accounts`, requestOptions)
    data = await response.json()
  } catch (error) {
    console.log("Error", error)
  }

  return data
}

export const getAnonymousCartData = async (cartId, onError = () => {}) => {
  try {
    const url = `${productsEndpoint}/carts/${cartId}`
    const response = await fetch(url)
    const data = await response.json()
    if (response?.ok) {
      return data
    }
    if (response?.status === 404) {
      localStorage.removeItem("cartId")
      return null
    }
    throw new Error()
  } catch (error) {
    console.log("Error", error)
    onError()
  }
  return null
}

export const provisionAccount = async (userKey, accountId, onError = () => {}) => {
  try {
    const url = `${accountsEndpoint}/accounts`
    const response = await fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${userKey}`,
        "x-account-id": accountId,
      },
      body: JSON.stringify({
        actionType: "DVWAccountProvision",
      }),
    })
    const data = await response.json()
    if (response?.ok) {
      return data
    }
    throw new Error()
  } catch (error) {
    console.log("Error", error)
    onError()
  }
  return null
}

export const getRegisteredCartData = async (
  userKey,
  accountId,
  onError = () => {}
) => {
  try {
    const url = `${productsEndpoint}/carts`
    const response = await fetch(url, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${userKey}`,
        "x-client-source": "MXP",
        "x-account-id": accountId,
      },
    })
    if (response.status === 401) {
      return null
    }
    const data = await response.json()
    if (response.ok) {
      return data
    }
    if (
      data?.errorCode === "PRODUCTS_1300" ||
      data?.errorCode === "PRODUCTS_1303"
    ) {
      return null
    }
    throw new Error()
  } catch (error) {
    console.log("Error", error)
    onError()
  }

  return null
}

export const assignAnonymousCart = async (
  userKey,
  accountId,
  anonymousCartId,
  onSubscriptionError = () => {},
  onGeolocationError = () => {},
  onMergeError = () => {},
  onError = () => {},
) => {
  try {
    const url = `${productsEndpoint}/carts/merge`
    const response = await fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${userKey}`,
        "x-account-id": accountId,
      },
      body: JSON.stringify({
        anonymousCartId: anonymousCartId,
      }),
    })
    const data = await response.json()
    if (data?.errorCode === "PRODUCTS_1604") {
      onSubscriptionError(data)
      return null
    }

    if (data?.errorCode === "PRODUCTS_1507" && data?.errorData?.removedSkus) {
      onGeolocationError(data)
    }

    if (data?.mergeWarning?.length) {
      onMergeError(data)
    }

    if (response?.ok) {
      return data
    }
    // throw new Error()
  } catch (error) {
    console.error("Error", error)
    onError()
  }

  return null
}

export const createAnonynousCart = async (
  currency,
  countryCode,
  lineItems,
  onGeolocationError = () => {},
  onError = () => {},
) => {
  try {
    const response = await fetch(`${productsEndpoint}/carts/anonymous`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        currency: currency,
        country: countryCode,
        lineItems: lineItems,
      }),
    })
    if (response?.ok) {
      return await response.json()
    }

    // check for US or CA anonymous cart and then switch to country outside US/CA for projectSight. This removes anonymous cart since API will fail
    const res = await response.json()
    if (
      res?.errorCode &&
      res.errorCode === "PRODUCTS_1507" &&
      res?.errorData?.removedSkus
    ) {
      onGeolocationError()
      return
    } else {
      throw new Error()
    }
  } catch (error) {
    console.error("Error", error)
    onError()
  }
  return null
}
